import { proxy } from "valtio"
import { CommonApi, UsersListResponse } from "../../generated"
import { apiConfig } from "../apiConfig"
import { isJa } from "../i18n/useLang"


export type UsersListStore = { items: UsersListResponse[], countrySet: Set<number> }

export const usersListStore = proxy<UsersListStore>({
  items: [],
  countrySet: new Set<number>(),
})

const api = new CommonApi(apiConfig)
export async function loadUsersLists() {
  await api.getUsersLists().then((result) => {
    usersListStore.items = result
    usersListStore.countrySet = new Set<number>(result.map((ul) => ul.country.id))
  })
}

export function getIsUsersListsCountry(store: UsersListStore, id: number) {
  return store.countrySet.has(id)
}

export function getIsChina(id: number) {
  // 中華人民共和国のIDは132
  return id === 132
}

export function findUsersList(store: UsersListStore, id: number): UsersListResponse & { label: string; value: string } | null {
  const found = store.items.find((o) => o.id === id)
  if (found === undefined) return null

  const result = updateAnotherNames(found)
  return { ...result, value: result?.id?.toString(), label: result?.name ?? '' }
}

function updateAnotherNames(found: UsersListResponse): UsersListResponse {
  if (found?.anotherNames === undefined || found?.anotherNames === null) {
    // anotherNamesが設定されてない場合undefinedを探してエラーになるので
    return { ...found, anotherNames: [] }
  } else {
    return found
  }
}

export function getUsersListResponses(usersLists: {
  items: UsersListResponse[]
}): {
  result: Array<UsersListResponse & { label: string; value: string }>,
  usersListSearchMap: Map<number, string>
} {
  const key = isJa() ? 'nameJa' : 'name'
  const result = usersLists.items.map((ul) => ({
    ...ul,
    value: ul.id.toString(),
    label: `${ul.name}(${ul.country[key]})`
  }))
  result.sort((a, b) => {
    if (a.label < b.label) {
      return -1
    } else if (a.label === b.label) {
      return 0
    } else {
      return 1
    }
  })

  const usersListSearchMap = new Map<number, string>()
  result.forEach((ul) => {
    const search = [ul.name, ul.country.name, ul.country.nameJa].concat(ul.anotherNames.map((an) => an.anotherName))
    usersListSearchMap.set(ul.id, search.join('___'))
  })
  return { result, usersListSearchMap }
}
